import * as React from 'react';
import invariant from 'invariant';
import { useKeyPressEvent } from 'react-use';
import ArrayUtils from "../../../utils/ArrayUtils";
import { mergeRefs } from "../../../helpers/common";
import { useMenuContext } from "../useMenuContext";

var useMenuList = function useMenuList(props) {
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var children = props.children;
  var menu = useMenuContext();
  invariant(menu, 'Missing Menu Context. Wrap component within Menu');
  var focusedIndex = menu.focusedIndex,
      setFocusedIndex = menu.setFocusedIndex,
      isOpen = menu.isOpen,
      onClose = menu.onClose,
      onToggle = menu.onToggle,
      menuItems = menu.menuItems,
      palette = menu.palette;

  var onArrowDown = function onArrowDown() {
    var nextIndex = ArrayUtils.getNextIndex(focusedIndex, menuItems.length);
    setFocusedIndex(nextIndex);
  };

  var onArrowUp = function onArrowUp() {
    var prevIndex = ArrayUtils.getPrevIndex(focusedIndex, menuItems.length);
    setFocusedIndex(prevIndex);
  };

  useKeyPressEvent('Enter', onToggle);
  useKeyPressEvent('ArrowDown', onArrowDown);
  useKeyPressEvent('ArrowUp', onArrowUp);
  useKeyPressEvent('Escape', onClose);
  return {
    ref: mergeRefs(menu.menuRef, ref),
    children: isOpen ? children : null,
    palette: palette
  };
};

export { useMenuList };
export default useMenuList;